import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button';
import { Link, useLocation } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import PaymentMode from './PaymentMode';
import { useHistory } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import { API_URL, IMAGE_URL, priceunit } from '../../Components/client-config';
import _ from 'lodash';
import jwtDecode from 'jwt-decode';
import { checkStoreActive, getProfile, getTimezone, getTimezoneForLater, saveCart, updateOnlineDeliveryFee } from '../../Redux';
import { toast } from 'react-toastify';
import moment from 'moment';
import { browserName, browserVersion } from "react-device-detect";
import { dumpCardTempOrder, emptyPaymentMethod, getPaymentModes, getTax, saveCardOrder, saveOrder, saveOrderSuccessFlag, savePaymentMethod, saveTrackingLogs } from '../../Redux/actions/payment';
import { cardDetails } from '../../Redux/actions/customer'
import CartItems from './CartItems';
import OrderDetail from './OrderDetail';
import * as geolib from 'geolib';
import KfcMeal from "../../Assetes/Images/kfc-meal.png"
import mergn from 'mergn-webapp-sdk';

import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import { donationCal } from '../../utils/donationCal';
import useCurrentLocale from '../../hooks/useLanguage';
import { useTranslation } from 'react-i18next';
import { PHONE_CODE } from '../../lib';
import { calcFinalPriceFromUnit, calcTotalGstTax, calculatePrice } from '../../utils/helpers';
import { couponDiscountCal } from '../../utils/menu.utils';
import { COUPON_TYPES } from '../../lib/constants';
import { ICartItem } from '../../lib/types';
import { formatPrice } from '../../utils/format-price';
var CryptoJS = require("crypto-js");
let cartTotal = 0;
let errorMesage = "";
let paymentPendingMessage = "";
function OrderSumary(props: any) {
    const cartData = useSelector((state: any) => state.cart.cartData);
    const cartQty = useSelector((state: any) => state.cart.cartQty);
    const cardTokens = useSelector((state: any) => state.customer.cardDetails);
    const storeSelected = useSelector((state: any) => state.store.storeSelected);
    const orderType = useSelector((state: any) => state.payment.orderType);
    const orderTime = useSelector((state: any) => state.payment.orderTime);
    const deliveryfee = useSelector((state: any) => state.store.deliveryfee);
    const onlineDeliveryfee = useSelector((state: any) => state.store.onlineDeliveryfee);
    const pos_fee = useSelector((state: any) => state.store.pos_fee);
    const delivery_address = useSelector((state: any) => state.payment.delivery_address);
    const geocoded_address = useSelector((state: any) => state.payment.geocoded_address);
    const isReverseCard = useSelector((state: any) => state.payment.payment_tax);
    const extra_address = useSelector((state: any) => state.payment.extra_address);
    const paymentMethod = useSelector((state: any) => state.payment.paymentMethod);
    const taxDataCash = useSelector((state: any) => state.store.taxDataCash);
    const taxDataCard = useSelector((state: any) => state.store.taxDataCard);
    const special_ins = useSelector((state: any) => state.cart.special_instructions);
    const alt_num = useSelector((state: any) => state.cart.alternate_number);
    const orderLaterDateTime = useSelector((state: any) => state.payment.orderLaterDateTime);
    const coupon = useSelector((state: any) => state.cart.coupon);
    const donationItems = useSelector((state: any) => state.cart.donationItems);
    const guestInfo = useSelector((state: any) => state.customer.guestInfo)
    const isLogged = useSelector((state: any) => state.customer.isLogged);
    const successFlag = useSelector((state: any) => state.payment.successFlag);
    const order_id = useSelector((state: any) => state.payment.order_id);
    const payment_modes = useSelector((state: any) => state.payment.payment_modes);
    const activeStore = useSelector((state: any) => state.store.activeStore);
    const propsPosition: any = useSelector((state: any) => state.payment.position);
    const { couponDetails } = useSelector((state: any) => state.menu);
    const couponDeliveryFree = useSelector((state: any) => state.menu.couponFreeDelivery);
    const [showError, setShowError] = useState(false)
    const [showPaymentPending, setShowPaymentPending] = useState(false)
    const [uniqueId, setUniqueId] = useState(new Date().getTime())
    const [radioButton, setRadioBtn] = useState(false)
    const [device_info, setDeviceInfo] = useState("")
    const [device_os, setDeviceOS] = useState("")
    const [value, setValue] = useState(0)
    const [loader, setLoader] = useState(false);
    const [removeableInvalidItemsArr, setRemoveableInvalidItemsArr]: any = useState([]);
    const [showValidteItemModal, setShowValidateItemModal] = useState(false);
    const [card_number, setCardNum] = useState("")
    const [cvn, setCVN] = useState("")
    const [isSaveCard, setIsSaveCard] = useState(false)
    const [card_expiry_month, setExpireMonth] = useState("")
    const [card_expiry_year, setExpireYear] = useState("")
    const [ip_address, setIP] = useState("");
    const search: any = useLocation().search;
    const [monthError, setMonthError] = useState(false)
    const [month2Error, setMonth2Error] = useState(true)
    const [yearError, setYearError] = useState(false)
    const [year2Error, setYear2Error] = useState(true)
    const [cvcError, setCvcError] = useState(false)
    const [cardError, setCardError] = useState(true)
    const [cardError2, setCardError2] = useState(false)
    const [cvc2Error, setCvc2Error] = useState(true)
    const [phone_number, setJazzCashPhone] = useState('')
    const [phoneError, setJazzCashPhoneError] = useState(false);
    const pickup_time = useSelector((state: any) => state.payment.pickupTime);
    const [isJazzCash, setIsJazzCash] = useState(false);
    const [CustomercardToken, setCustomercardToken] = useState<{ card_type: string, is_default: boolean, masked_card: string, payment_token: string, id: number } | null>(null);
    const [isNewCard, setIsNewCard] = useState(false);
    const lang = useCurrentLocale();
    const { t } = useTranslation();


    const handleCardNumber = (value: any) => {
        setCardNum(value)
        setCardError(false)
    }
    const handleCardError2 = (value: any) => {
        setCardError2(value)
    }
    const newCardHandler = (value: any) => {
        setIsNewCard(value)
    }
    const handleCardCVN = (value: any) => {
        if (value.length <= 3)
            setCVN(value)
        if (value.length < 3)
            setCvcError(true)
        else setCvcError(false)

        setCvc2Error(false);
    }
    const handleCardExpireMonth = (value: any) => {
        if (value.length <= 2)
            setExpireMonth(value)
        if (value.length < 2)
            setMonthError(true)
        else setMonthError(false);

        setMonth2Error(false);
    }
    const handleCardExpireYear = (value: any) => {
        if (value.length <= 4)
            setExpireYear(value)
        if (value.length < 4)
            setYearError(true)
        else setYearError(false)

        setYear2Error(false);
    }
    const handleSaveDetails = (value: any) => {
        setIsSaveCard(value)
    }
    useEffect(() => {
        let token: any = localStorage.getItem("userToken");
        if (isLogged || guestInfo) {
            if (token) {
                let userData: any = jwtDecode(token);
                setJazzCashPhone(userData.customer.phone_number.substring(1))
            } else {
                setJazzCashPhone(guestInfo.phone_number.substring(1))
            }
        }
        if (storeSelected) {
            props.checkStoreActive(storeSelected.store_id, orderType)
        }
        let detectOS = "Unknown OS"

        if (navigator.appVersion.indexOf("Win") != -1) detectOS = "Windows"

        if (navigator.appVersion.indexOf("Mac") != -1) detectOS = "MacOS"

        if (navigator.appVersion.indexOf("Linux") != -1) detectOS = "Linux"
        let deviceInfo = (`${detectOS},${browserName} ${browserVersion}`);
        setDeviceInfo(deviceInfo)
        setDeviceOS(detectOS)
        getIP()
        props.emptyPaymentMethod()
        props.saveOrderSuccessFlag()
        props.updateOnlineDeliveryFee(0)
    }, [])
    const getIP = async () => {
        const res = await axios.get("https://api.ipify.org/?format=json");
        setIP(res.data.ip);
    };

    useEffect(() => {
        if (paymentMethod == "Card") {
            setCardNum("")
            setCVN("")
            setExpireMonth("")
            setExpireYear("")
            setMonthError(false)
            setMonth2Error(true)
            setYearError(false)
            setYear2Error(true)
            setCvcError(false)
            setCardError(true)
            setCardError2(false)
            setCvc2Error(true)
            setIsNewCard(false)
        }
    }, [paymentMethod])

    useEffect(() => {
        cardTokens && cardTokens.forEach((token: any) => {
            if (token.is_default == 1) {
                if (isNewCard == false) {
                    setCustomercardToken(token)
                }
                else {
                    setCustomercardToken(null)
                }
            }
        });
    }, [cardTokens, isNewCard])

    useEffect(() => {
        const validateCart = async () => {
            let data: any = cartData;
            if (data && data.length > 0) {
                let cart: any = data;
                let obj: any = {
                    cart: cart,
                    mode: 'online',
                    channel: orderType,
                    store_id: storeSelected ? Number(storeSelected.store_id) : null,
                }
                if (orderTime == "later") {
                    obj.future_date = moment(orderLaterDateTime).utc(false).format('YYYY-MM-DD HH:mm');
                }
                var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(obj), process.env.REACT_APP_EncryptionKey).toString();
                axios.post(`${API_URL}menu/validateCart`, { body: encryptedData }).then((res: any) => {
                    let invalidCart = res.data.data;
                    let InvalidItemRemove: any = [];
                    for (let i = 0; i < cartData.length; i++) {
                        let found = 0;
                        if (cartData[i].item) {
                            if (invalidCart?.length > 0) {
                                for (let j = 0; j < invalidCart.length; j++) {
                                    if (cartData[i].selectedsize.id === invalidCart[j].variant_id) {
                                        found = 1;
                                        break;
                                    }
                                }
                                if (found == 0) {
                                    InvalidItemRemove.push(cartData[i]);
                                    setRemoveableInvalidItemsArr(InvalidItemRemove);
                                }
                            } else {
                                InvalidItemRemove.push(cartData[i]);
                                setRemoveableInvalidItemsArr(InvalidItemRemove);
                            }
                        } else {
                            if (invalidCart?.length > 0) {
                                for (let j = 0; j < invalidCart.length; j++) {
                                    if (cartData[i].combo.combo_id == invalidCart[j].combo_id) {
                                        found = 1;
                                        break;
                                    }
                                }
                                if (found == 0) {
                                    InvalidItemRemove.push(cartData[i]);
                                    setRemoveableInvalidItemsArr(InvalidItemRemove);
                                }
                            } else {
                                InvalidItemRemove.push(cartData[i]);
                                setRemoveableInvalidItemsArr(InvalidItemRemove);
                            }
                        }
                    }
                    if (InvalidItemRemove.length > 0) {
                        setShowValidateItemModal(true);
                    } else {
                        setShowValidateItemModal(false);
                    }
                })
                    .catch(err => {
                        setShowValidateItemModal(false)
                    })
            }
        };
        setTimeout(() => {
            validateCart();
        }, 1000)
    }, [])

    useEffect(() => {
        const paramstoken = new URLSearchParams(search).get('token');
        if (paramstoken) {
            let decodedparams: any = jwtDecode(paramstoken)
            if (decodedparams.reason_code == "100") {
                toast.success(t("PAYMENT_SUCCESSFULLY_COMPLETED"), {
                    position: toast.POSITION.TOP_RIGHT,
                    hideProgressBar: true,
                    autoClose: 3000,
                });
                props.dumpCardTempOrder(decodedparams, orderTime);
            }
            // reason_code : 476 (decision: DECLINE)  (message: 'Payer could not be authenticated.',')  
            // req_customer_ip_address     req_reference_number

            // reason_code : 481 (decision: REJECT) due to CyberSource suspecious multiple requests from same IP  
            // req_customer_ip_address     req_reference_number

            // reason_code : 100  (decision: ACCEPT)   (message: 'Request was processed successfully.') 
            // req_customer_ip_address    req_reference_number

            // reason_code : 102 (decision: ERROR) (message: Request parameters are invalid or missing') req_customer_ip_address  ( invalid_fields: 'card_number')  
            //  req_reference_number

            // if (decodedparams.reason_code == "102" || decodedparams.reason_code == "476") {
            //     toast.error("Payment is unsuccessful", {
            //         position: toast.POSITION.TOP_RIGHT,
            //         hideProgressBar: true,
            //         autoClose: 3000,
            //     });
            // }
            // if (decodedparams.reason_code == "481") {
            //     toast.error("Payment is rejected", {
            //         position: toast.POSITION.TOP_RIGHT,
            //         hideProgressBar: true,
            //         autoClose: 3000,
            //     });
            //     // props.dumpCardTempOrder(decodedparams.req_reference_number, orderTime); 
            // }
            if (decodedparams.invalid_fields) {
                toast.error(`${decodedparams.message} (${decodedparams.invalid_fields})`, {
                    position: toast.POSITION.TOP_RIGHT,
                    hideProgressBar: true,
                    autoClose: 3000,
                });
            } else {
                if (decodedparams.reason_code !== "100") {
                    toast.error(decodedparams.message, {
                        position: toast.POSITION.TOP_RIGHT,
                        hideProgressBar: true,
                        autoClose: 3000,
                    });
                }
            }
        }
    }, [])

    useEffect(() => {
        cartData.map((product: any) => {
            if (product.item && product.item.item_size[0] && product.item.item_size[0].is_jazz_cash && product.item.item_size[0].is_jazz_cash === 1) {
                setIsJazzCash(true)
            }
            if (product.combo && product.combo.is_jazz_cash && product.combo.is_jazz_cash === 1) {
                setIsJazzCash(true)
            }
            if (product.item && product.item.item_size && product.item.item_size.is_jazz_cash === 1) {
                setIsJazzCash(true)
            }
        })
    }, [cartData])

    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
        props.savePaymentMethod("")
        props.updateOnlineDeliveryFee(0)
        cartData.forEach((item: any) => {
            item.updateOnlineItemPrice = 0
        })
        paymentTracking(`Close Payment Mode Modal`)
    }
    const handleShow = () => {
        setShow(true)
        props.savePaymentMethod("")
        props.getPaymentModes(storeSelected.store_id);
        props.getCustomerCardDetails()
        paymentTracking(`Select Payment Mode Button`)
        taxCalculations()
    };
    const history = useHistory();
    const handleTrack = () => {
        props.saveOrderSuccessFlag()
        paymentTracking(`Select Track Order OK Button`)
        history.push(`/${lang}/track-order`);
    }
    const removeInvalidCartItem = () => {
        if (cartData && cartData.length > 0) {
            const filteredCart = cartData.filter((item: any) => {
                return !removeableInvalidItemsArr.some((removeableItem: any) => {
                    if (item.selectedsize && removeableItem.selectedsize) {
                        return item.selectedsize.id === removeableItem.selectedsize.id;
                    } else if (item.combo && removeableItem.combo) {
                        return item.combo.combo_id === removeableItem.combo.combo_id;
                    }
                    return false;
                });
            });
            props.saveCart(filteredCart)
            setValue(value + 1)
            props.setHeaderUpdate(props.headerUpdate + 1)
            setShowValidateItemModal(false);
            if (cartData.length === 0) {
                history.push(`/${lang}/`);
            }
        } else {
            setShowValidateItemModal(false);
        }
    };
    const calcTotal = (data: ICartItem[]) => {
        const couponPercentValue = (couponDetails && !couponDeliveryFree && (couponDetails.coupon_type.type == COUPON_TYPES.PERCENT || couponDetails.coupon_type.type == COUPON_TYPES.VALUE)) ? 1 : 0;
        let sum: any = 0;
        data.forEach((item: ICartItem) => {
            if (item.updateOnlineItemPrice && item.updateOnlineItemPrice > 0) {
                sum += item.updateOnlineItemPrice;
            } else {
                sum += item.totalItemPrice;
            }
        });
        if (orderType == "Delivery") {
            if (!_.isEmpty(storeSelected)) {
                sum = pos_fee > 0 ? sum + (onlineDeliveryfee > 0 ? onlineDeliveryfee : deliveryfee) + Number(pos_fee) : sum + (onlineDeliveryfee > 0 ? onlineDeliveryfee : deliveryfee);
            }
            else {
                sum = pos_fee > 0 ? sum + Number(pos_fee) : sum;
            }
        } else if (orderType == "Pickup") {
            sum = pos_fee > 0 ? sum + Number(pos_fee) : sum;
        }
        if (donationItems?.length > 0) {
            donationItems.map((item: any) => {
                sum += Number(item.totalItemPrice);
            })
        }
        if(couponDetails && couponPercentValue) {
            sum -= couponDiscountCal(couponDetails, cartData)
        }
        if(couponDeliveryFree) {
            sum -= deliveryfee
        }
        cartTotal = Math.round(sum * 100) / 100;
        let finalSum = sum;
        return Math.round(finalSum * 100) / 100;
    };
    const HoursArray = (hourDiff: any, starttime: any) => {
        if (String(hourDiff).indexOf('-') !== -1) {
            hourDiff = hourDiff + 24;
        }
        var hours: any = [];
        let hour = starttime;
        for (let i = 0; i <= hourDiff; i++) {
            hour = starttime + i;
            let AmOrPm = '';
            hour >= 12 && hour < 24 ? (AmOrPm = 'pm') : (AmOrPm = 'am');
            hour = hour % 12 || 12;
            hours.push(hour + AmOrPm);
        }
        var string = hours.join(':');
        return string;
    };
    //Later Case
    const compareLaterOpenClosingTime = (storeSelected: any, obj: any) => {
        props.getTimezoneForLater(storeSelected.store_id).then((serverTime: any) => {
            let dateIndexServer = serverTime.date.indexOf("T")
            let laterdatetime = orderLaterDateTime;
            let serverDate = serverTime.date.slice(0, dateIndexServer)
            let dateIndexClient = laterdatetime.indexOf("T")
            let clientDate = laterdatetime.slice(0, dateIndexClient)
            let todayValidDate: any = new Date();
            let t = todayValidDate.getDate()
            let validDate = parseInt(t) == parseInt(serverDate.split("-")[2]) && serverDate.split("-")[0] == clientDate.split("-")[0] && serverDate.split("-")[1] == clientDate.split("-")[1] && (parseInt(serverDate.split("-")[2]) == parseInt(clientDate.split("-")[2]) || parseInt(serverDate.split("-")[2]) == parseInt(clientDate.split("-")[2]))
            if (validDate) {
                let addedTime: any = null;
                let today = new Date();
                let todayHours = today.getHours()

                if (todayHours != parseInt(serverTime.time.split(":")[0])) {
                    toast.error(t("INVALID_DEVICE_TIME"), {
                        position: toast.POSITION.TOP_RIGHT,
                        hideProgressBar: true,
                        autoClose: 3000,
                    });
                }
                let laterDate = new Date(laterdatetime);
                let futureHours: any = laterDate.getHours();
                let futureMinutes: any = laterDate.getMinutes();

                if (addedTime) {
                    futureHours = addedTime.split(":")[0];
                    futureMinutes = addedTime.split(":")[1];
                }

                let futureAmOrPm = futureHours >= 12 ? 'pm' : 'am';
                futureHours = futureHours % 12 || 12;
                let futuretime: any = futureHours + '' + futureAmOrPm;
                //define hours or minutes
                var timeStartMin = new Date(
                    '01/01/2007 ' + storeSelected.store_open_time,
                ).getMinutes();
                var timeEndMin = new Date(
                    '01/01/2007 ' + storeSelected.store_close_time,
                ).getMinutes();
                var timeStartHours = new Date(
                    '01/01/2007 ' + storeSelected.store_open_time,
                ).getHours();
                var timeEndHours = new Date(
                    '01/01/2007 ' + storeSelected.store_close_time,
                ).getHours();
                var hourDiff: any = timeEndHours - timeStartHours;
                let HourString = HoursArray(hourDiff, timeStartHours);
                let splitHourArray = HourString.split(":")
                if (splitHourArray.indexOf(futuretime) !== -1) { //if Pick Hour with am/pm is exist in HourString
                    if (timeStartMin == 0 && timeEndMin == 0) {  //if store opening minutes and closing minutes are 00
                        if (splitHourArray.length - 1 == splitHourArray.indexOf(futuretime)) {
                            //if Pick Hour with am/pm is exist in HourString at last index
                            setLoader(false)
                            setRadioBtn(false)
                            toast.error(t("STORE_CLOSED"), {
                                position: toast.POSITION.TOP_RIGHT,
                                hideProgressBar: true,
                                autoClose: 3000,
                            });
                        } else {
                            if (obj.payment_method == "Card" || obj.payment_method == "JazzWallet") {
                                props.saveCardOrder(obj, updateLoaderButton, updateCartInOriginalStateAfterException, setShowPaymentPending, showPaymentPendingMessage, handleClose);
                            } else {
                                props.saveOrder(obj, setLoader, handleClose, setShowError, showErrorMessage, updateLoaderButton, updateCartInOriginalStateAfterException);
                            }
                        }
                    } else {
                        if (timeStartMin == 0 || timeEndMin == 0) {  //if store opening or closing minute is 00
                            if (splitHourArray.length - 1 == splitHourArray.indexOf(futuretime)) {
                                if (futureMinutes < timeEndMin) {
                                    if (obj.payment_method == "Card" || obj.payment_method == "JazzWallet") {
                                        props.saveCardOrder(obj, updateLoaderButton, updateCartInOriginalStateAfterException, setShowPaymentPending, showPaymentPendingMessage, handleClose);
                                    } else {
                                        props.saveOrder(obj, setLoader, handleClose, setShowError, showErrorMessage, updateLoaderButton, updateCartInOriginalStateAfterException);
                                    }
                                } else {
                                    setLoader(false)
                                    setRadioBtn(false)
                                    toast.error(t("STORE_CLOSED"), {
                                        position: toast.POSITION.TOP_RIGHT,
                                        hideProgressBar: true,
                                        autoClose: 3000,
                                    });
                                }
                            } else {
                                if (obj.payment_method == "Card" || obj.payment_method == "JazzWallet") {
                                    props.saveCardOrder(obj, updateLoaderButton, updateCartInOriginalStateAfterException, setShowPaymentPending, showPaymentPendingMessage, handleClose);
                                } else {
                                    props.saveOrder(obj, setLoader, handleClose, setShowError, showErrorMessage, updateLoaderButton, updateCartInOriginalStateAfterException);
                                }
                            }
                        } else { //if store opening or closing minute is not 00
                            if (
                                futureMinutes > timeStartMin ||
                                futureMinutes < timeEndMin
                            ) {
                                if (obj.payment_method == "Card" || obj.payment_method == "JazzWallet") {
                                    props.saveCardOrder(obj, updateLoaderButton, updateCartInOriginalStateAfterException, setShowPaymentPending, showPaymentPendingMessage, handleClose);
                                } else {
                                    props.saveOrder(obj, setLoader, handleClose, setShowError, showErrorMessage, updateLoaderButton, updateCartInOriginalStateAfterException);
                                }
                            } else {
                                setLoader(false)
                                setRadioBtn(false)
                                toast.error(t("STORE_CLOSED"), {
                                    position: toast.POSITION.TOP_RIGHT,
                                    hideProgressBar: true,
                                    autoClose: 3000,
                                });
                            }
                        }
                    }
                } else {
                    setLoader(false)
                    setRadioBtn(false)
                    toast.error(t("STORE_CLOSED"), {
                        position: toast.POSITION.TOP_RIGHT,
                        hideProgressBar: true,
                        autoClose: 3000,
                    });
                }
            } else {
                toast.error(t("INVALID_DEVICE_TIME"), {
                    position: toast.POSITION.TOP_RIGHT,
                    hideProgressBar: true,
                    autoClose: 3000,
                });
            }
        })
    }
    const compareLaterTimingbyEachDay = (storeSelected: any, obj: any) => {
        props.getTimezoneForLater(props.storeSelected.store_id).then((serverTime: any) => {
            let dateIndexServer = serverTime.date.indexOf("T")
            var laterdatetime = orderLaterDateTime;
            let serverDate = serverTime.date.slice(0, dateIndexServer)
            let dateIndexClient = laterdatetime.indexOf("T")
            let clientDate = laterdatetime.slice(0, dateIndexClient)
            let todayValidDate: any = new Date();
            let t = todayValidDate.getDate()
            let validDate = parseInt(t) == parseInt(serverDate.split("-")[2]) && serverDate.split("-")[0] == clientDate.split("-")[0] && serverDate.split("-")[1] == clientDate.split("-")[1] && (parseInt(serverDate.split("-")[2]) == parseInt(clientDate.split("-")[2]) || parseInt(serverDate.split("-")[2]) + 1 == parseInt(clientDate.split("-")[2]))
            if (validDate) {
                let today = new Date();
                let todayHours = today.getHours()

                if (todayHours != parseInt(serverTime.time.split(":")[0])) {
                    toast.error(t("INVALID_DEVICE_TIME"), {
                        position: toast.POSITION.TOP_RIGHT,
                        hideProgressBar: true,
                        autoClose: 3000,
                    });
                }
                let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                let weekDaysTimingArr = JSON.parse(storeSelected.daysTiming)
                let futureDay = new Date(laterdatetime).getDay();
                let dayName = days[futureDay];
                weekDaysTimingArr.map((storeDay: any) => {
                    if (dayName == storeDay.day) {
                        let laterDate = new Date(laterdatetime);
                        let futureHours: any = laterDate.getHours();
                        let futureMinutes: any = laterDate.getMinutes();
                        let futureAmOrPm = futureHours >= 12 ? 'pm' : 'am';
                        futureHours = futureHours % 12 || 12;
                        let futuretime: any = futureHours + '' + futureAmOrPm;
                        //define hours or minutes
                        var timeStartMin = new Date(
                            '01/01/2007 ' + storeDay.opening,
                        ).getMinutes();
                        var timeEndMin = new Date(
                            '01/01/2007 ' + storeDay.closing,
                        ).getMinutes();
                        var timeStartHours = new Date(
                            '01/01/2007 ' + storeDay.opening,
                        ).getHours();
                        var timeEndHours = new Date(
                            '01/01/2007 ' + storeDay.closing,
                        ).getHours();
                        var hourDiff: any = timeEndHours - timeStartHours;
                        let HourString = HoursArray(hourDiff, timeStartHours);
                        let splitHourArray = HourString.split(":")
                        if (splitHourArray.indexOf(futuretime) !== -1) { //if Pick Hour with am/pm is exist in HourString
                            if (timeStartMin == 0 && timeEndMin == 0) {  //if store opening minutes and closing minutes are 00
                                if (splitHourArray.length - 1 == splitHourArray.indexOf(futuretime)) {
                                    //if Pick Hour with am/pm is exist in HourString at last index
                                    setLoader(false)
                                    setRadioBtn(false)
                                    toast.error(t("STORE_CLOSED"), {
                                        position: toast.POSITION.TOP_RIGHT,
                                        hideProgressBar: true,
                                        autoClose: 3000,
                                    });
                                } else {
                                    if (obj.payment_method == "Card" || obj.payment_method == "JazzWallet") {
                                        props.saveCardOrder(obj, updateLoaderButton, updateCartInOriginalStateAfterException, setShowPaymentPending, showPaymentPendingMessage, handleClose);
                                    } else {
                                        props.saveOrder(obj, setLoader, handleClose, setShowError, showErrorMessage, updateLoaderButton, updateCartInOriginalStateAfterException);
                                    }
                                }
                            } else {
                                if (timeStartMin == 0 || timeEndMin == 0) {  //if store opening or closing minute is 00
                                    if (splitHourArray.length - 1 == splitHourArray.indexOf(futuretime)) {
                                        if (futureMinutes < timeEndMin) {
                                            if (obj.payment_method == "Card" || obj.payment_method == "JazzWallet") {
                                                props.saveCardOrder(obj, updateLoaderButton, updateCartInOriginalStateAfterException, setShowPaymentPending, showPaymentPendingMessage, handleClose);
                                            } else {
                                                props.saveOrder(obj, setLoader, handleClose, setShowError, showErrorMessage, updateLoaderButton, updateCartInOriginalStateAfterException);
                                            }
                                        } else {
                                            setLoader(false)
                                            setRadioBtn(false)
                                            toast.error(t("STORE_CLOSED"), {
                                                position: toast.POSITION.TOP_RIGHT,
                                                hideProgressBar: true,
                                                autoClose: 3000,
                                            });
                                        }
                                    } else {
                                        if (obj.payment_method == "Card" || obj.payment_method == "JazzWallet") {
                                            props.saveCardOrder(obj, updateLoaderButton, updateCartInOriginalStateAfterException, setShowPaymentPending, showPaymentPendingMessage, handleClose);
                                        } else {
                                            props.saveOrder(obj, setLoader, handleClose, setShowError, showErrorMessage, updateLoaderButton, updateCartInOriginalStateAfterException);
                                        }
                                    }
                                } else { //if store opening or closing minute is not 00
                                    if (
                                        futureMinutes > timeStartMin ||
                                        futureMinutes < timeEndMin
                                    ) {
                                        if (obj.payment_method == "Card" || obj.payment_method == "JazzWallet") {
                                            props.saveCardOrder(obj, updateLoaderButton, updateCartInOriginalStateAfterException, setShowPaymentPending, showPaymentPendingMessage, handleClose);
                                        } else {
                                            props.saveOrder(obj, setLoader, handleClose, setShowError, showErrorMessage, updateLoaderButton, updateCartInOriginalStateAfterException);
                                        }
                                    } else {
                                        setLoader(false)
                                        setRadioBtn(false)
                                        toast.error(t("STORE_CLOSED"), {
                                            position: toast.POSITION.TOP_RIGHT,
                                            hideProgressBar: true,
                                            autoClose: 3000,
                                        });
                                    }
                                }
                            }
                        } else {
                            setLoader(false)
                            setRadioBtn(false)
                            toast.error(t("STORE_CLOSED"), {
                                position: toast.POSITION.TOP_RIGHT,
                                hideProgressBar: true,
                                autoClose: 3000,
                            });
                        }
                    }
                })
            } else {
                toast.error(t("INVALID_DEVICE_TIME"), {
                    position: toast.POSITION.TOP_RIGHT,
                    hideProgressBar: true,
                    autoClose: 3000,
                });
            }
        })
    }
    //Now Case
    const compareOpenClosingTime = (storeSelected: any, obj: any) => {
        props.getTimezone(storeSelected.store_id).then((serverTime: any) => {
            //convert the current time 24 hour to 12 hour
            let CurrentHours: any = serverTime.split(":")[0];
            let currentMinutes: any = serverTime.split(":")[1];
            let CurrentAmOrPm = CurrentHours >= 12 ? 'pm' : 'am';
            CurrentHours = CurrentHours % 12 || 12;
            let Currenttime: any = CurrentHours + '' + CurrentAmOrPm;
            //define hours or minutes
            var timeStartMin = new Date(
                '01/01/2007 ' + storeSelected.store_open_time,
            ).getMinutes();
            var timeEndMin = new Date(
                '01/01/2007 ' + storeSelected.store_close_time,
            ).getMinutes();
            var timeStartHours = new Date(
                '01/01/2007 ' + storeSelected.store_open_time,
            ).getHours();
            var timeEndHours = new Date(
                '01/01/2007 ' + storeSelected.store_close_time,
            ).getHours();
            var hourDiff: any = timeEndHours - timeStartHours;
            let HourString = HoursArray(hourDiff, timeStartHours);
            let splitHourArray = HourString.split(":")
            if (splitHourArray.indexOf(Currenttime) !== -1) { //if Pick Hour with am/pm is exist in HourString
                if (timeStartMin == 0 && timeEndMin == 0) {  //if store opening minutes and closing minutes are 00
                    if (splitHourArray.length - 1 == splitHourArray.indexOf(Currenttime)) {
                        //if Pick Hour with am/pm is exist in HourString at last index
                        setLoader(false)
                        setRadioBtn(false)
                        toast.error(t("STORE_CLOSED"), {
                            position: toast.POSITION.TOP_RIGHT,
                            hideProgressBar: true,
                            autoClose: 3000,
                        });
                    } else {
                        if (obj.payment_method == "Card" || obj.payment_method == "JazzWallet") {
                            props.saveCardOrder(obj, updateLoaderButton, updateCartInOriginalStateAfterException, setShowPaymentPending, showPaymentPendingMessage, handleClose);
                        } else {
                            props.saveOrder(obj, setLoader, handleClose, setShowError, showErrorMessage, updateLoaderButton, updateCartInOriginalStateAfterException);
                        }
                    }
                } else {
                    if (timeStartMin == 0 || timeEndMin == 0) {  //if store opening or closing minute is 00
                        if (splitHourArray.length - 1 == splitHourArray.indexOf(Currenttime)) {
                            if (currentMinutes < timeEndMin) {
                                if (obj.payment_method == "Card" || obj.payment_method == "JazzWallet") {
                                    props.saveCardOrder(obj, updateLoaderButton, updateCartInOriginalStateAfterException, setShowPaymentPending, showPaymentPendingMessage, handleClose);
                                } else {
                                    props.saveOrder(obj, setLoader, handleClose, setShowError, showErrorMessage, updateLoaderButton, updateCartInOriginalStateAfterException);
                                }
                            } else {
                                setLoader(false)
                                setRadioBtn(false)
                                toast.error(t("STORE_CLOSED"), {
                                    position: toast.POSITION.TOP_RIGHT,
                                    hideProgressBar: true,
                                    autoClose: 3000,
                                });
                            }
                        } else {
                            if (obj.payment_method == "Card" || obj.payment_method == "JazzWallet") {
                                props.saveCardOrder(obj, updateLoaderButton, updateCartInOriginalStateAfterException, setShowPaymentPending, showPaymentPendingMessage, handleClose);
                            } else {
                                props.saveOrder(obj, setLoader, handleClose, setShowError, showErrorMessage, updateLoaderButton, updateCartInOriginalStateAfterException);
                            }
                        }
                    } else { //if store opening or closing minute is not 00
                        if (
                            currentMinutes > timeStartMin ||
                            currentMinutes < timeEndMin
                        ) {
                            if (obj.payment_method == "Card" || obj.payment_method == "JazzWallet") {
                                props.saveCardOrder(obj, updateLoaderButton, updateCartInOriginalStateAfterException, setShowPaymentPending, showPaymentPendingMessage, handleClose);
                            } else {
                                props.saveOrder(obj, setLoader, handleClose, setShowError, showErrorMessage, updateLoaderButton, updateCartInOriginalStateAfterException);
                            }
                        } else {
                            setLoader(false)
                            setRadioBtn(false)
                            toast.error(t("STORE_CLOSED"), {
                                position: toast.POSITION.TOP_RIGHT,
                                hideProgressBar: true,
                                autoClose: 3000,
                            });
                        }
                    }
                }
            } else {
                setLoader(false)
                setRadioBtn(false)
                toast.error(t("STORE_CLOSED"), {
                    position: toast.POSITION.TOP_RIGHT,
                    hideProgressBar: true,
                    autoClose: 3000,
                });
            }
        })
    }
    const compareTimingbyEachDay = (storeSelected: any, obj: any, channel: any) => {
        props.getTimezoneForLater(storeSelected.store_id).then((serverTime: any) => {
            let dateIndexServer = serverTime.date.indexOf("T")
            let serverDate = serverTime.date.slice(0, dateIndexServer)

            let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            let weekDaysTimingArr = JSON.parse(storeSelected.channel_days_timing)
            let todayDay = new Date(serverDate).getDay();
            let dayName = days[todayDay];


            weekDaysTimingArr.map((storeDay: any) => {
                if (dayName == storeDay.day) {
                    let timePeriods = storeDay.timePeriods;
                    let storeOpenTime = null;
                    let storeCloseTime = null;
                    timePeriods.map((period: any) => {
                        if (period.channel == channel) {
                            storeOpenTime = period.opening;
                            storeCloseTime = period.closing;
                        }
                    })
                    let today = new Date();
                    let CurrentHours: any = serverTime.time.split(":")[0]
                    let currentMinutes: any = serverTime.time.split(":")[1]
                    let CurrentAmOrPm = CurrentHours >= 12 ? 'pm' : 'am';
                    CurrentHours = CurrentHours % 12 || 12;
                    let Currenttime: any = CurrentHours + '' + CurrentAmOrPm;
                    //define hours or minutes
                    var timeStartMin = new Date(
                        '01/01/2007 ' + storeOpenTime,
                    ).getMinutes();
                    var timeEndMin = new Date(
                        '01/01/2007 ' + storeCloseTime,
                    ).getMinutes();
                    var timeStartHours = new Date(
                        '01/01/2007 ' + storeOpenTime,
                    ).getHours();
                    var timeEndHours = new Date(
                        '01/01/2007 ' + storeCloseTime,
                    ).getHours();
                    var hourDiff: any = timeEndHours - timeStartHours;
                    let HourString = HoursArray(hourDiff, timeStartHours);
                    let splitHourArray = HourString.split(":")

                    if (splitHourArray.indexOf(Currenttime) !== -1) { //if Pick Hour with am/pm is exist in HourString
                        if (timeStartMin == 0 && timeEndMin == 0) {  //if store opening minutes and closing minutes are 00
                            if (splitHourArray.length - 1 == splitHourArray.indexOf(Currenttime)) {
                                //if Pick Hour with am/pm is exist in HourString at last index
                                setLoader(false)
                                setRadioBtn(false)
                                toast.error(t("STORE_CLOSED"), {
                                    position: toast.POSITION.TOP_RIGHT,
                                    hideProgressBar: true,
                                    autoClose: 3000,
                                });
                            } else {
                                if (obj.payment_method == "Card" || obj.payment_method == "JazzWallet") {
                                    props.saveCardOrder(obj, updateLoaderButton, updateCartInOriginalStateAfterException, setShowPaymentPending, showPaymentPendingMessage, handleClose);
                                } else {
                                    props.saveOrder(obj, setLoader, handleClose, setShowError, showErrorMessage, updateLoaderButton, updateCartInOriginalStateAfterException);
                                }

                            }
                        } else {
                            if (timeStartMin == 0 || timeEndMin == 0) {  //if store opening or closing minute is 00
                                if (splitHourArray.length - 1 == splitHourArray.indexOf(Currenttime)) {
                                    if (currentMinutes < timeEndMin) {
                                    } else {
                                        setLoader(false)
                                        setRadioBtn(false)
                                        toast.error(t("STORE_CLOSED"), {
                                            position: toast.POSITION.TOP_RIGHT,
                                            hideProgressBar: true,
                                            autoClose: 3000,
                                        });
                                    }
                                } else {
                                    if (obj.payment_method == "Card" || obj.payment_method == "JazzWallet") {
                                        props.saveCardOrder(obj, updateLoaderButton, updateCartInOriginalStateAfterException, setShowPaymentPending, showPaymentPendingMessage, handleClose);
                                    } else {
                                        props.saveOrder(obj, setLoader, handleClose, setShowError, showErrorMessage, updateLoaderButton, updateCartInOriginalStateAfterException);
                                    }
                                }
                            } else { //if store opening or closing minute is not 00
                                if (
                                    currentMinutes > timeStartMin ||
                                    currentMinutes < timeEndMin
                                ) {
                                    if (obj.payment_method == "Card" || obj.payment_method == "JazzWallet") {
                                        props.saveCardOrder(obj, updateLoaderButton, updateCartInOriginalStateAfterException, setShowPaymentPending, showPaymentPendingMessage, handleClose);
                                    } else {
                                        props.saveOrder(obj, setLoader, handleClose, setShowError, showErrorMessage, updateLoaderButton, updateCartInOriginalStateAfterException);
                                    }
                                } else {
                                    setLoader(false)
                                    setRadioBtn(false)
                                    toast.error(t("STORE_CLOSED"), {
                                        position: toast.POSITION.TOP_RIGHT,
                                        hideProgressBar: true,
                                        autoClose: 3000,
                                    });
                                }
                            }
                        }
                    } else {
                        setLoader(false)
                        setRadioBtn(false)
                        toast.error(t("STORE_CLOSED"), {
                            position: toast.POSITION.TOP_RIGHT,
                            hideProgressBar: true,
                            autoClose: 3000,
                        });
                    }
                    return;
                }
            })
        })
    }
    const confirmOrder = async () => {
        setLoader(true)
        let lat = sessionStorage.getItem("lat")
        let lng = sessionStorage.getItem("lng")
        let changeLat: any = propsPosition?.lat;
        let changeLng: any = propsPosition?.lng;
        let uniqueOrderId = uniqueId;
        let tax: any = 0;
        tax = paymentMethod == 'Cash' ? taxDataCash ? taxDataCash.tax_percent : 0 : taxDataCard ? taxDataCard.tax_percent : 0;
        breakme: if (activeStore) {
            let totalDeliveryFee = 0;
            if (paymentMethod !== 'Cash' && isReverseCard) {
                const delFee = calculateDeliveryFee();
                totalDeliveryFee += delFee;
            }
            let total_delivery_fee = (paymentMethod !== 'Cash' && isReverseCard) ? orderType == "Delivery" ? totalDeliveryFee : 0 : deliveryfee;
            if(couponDeliveryFree) {
                total_delivery_fee = 0;
            }
            let totalPrice = 0;
            const couponPercentValue = (couponDetails && !couponDeliveryFree && (couponDetails.coupon_type.type == COUPON_TYPES.PERCENT || couponDetails.coupon_type.type == COUPON_TYPES.VALUE)) ? 1 : 0;
            cartData.forEach((item: any) => {
                if (paymentMethod !== 'Cash' && isReverseCard) {
                    if (couponPercentValue) {
                        const originalPrice = (item.item && item.selectedsize) 
                            ? item.selectedsize.mrp 
                            : (item.combo ? item.combo.combo_mrp_price : item.price);
                        const tempItem = { ...item, price: originalPrice };
                        const final_price = calcFinalPriceFromUnit(tempItem, paymentMethod, taxDataCash, taxDataCard, isReverseCard);
                        totalPrice += final_price;
                    } else {
                        const final_price = calcFinalPriceFromUnit(item, paymentMethod, taxDataCash, taxDataCard, isReverseCard);
                        totalPrice += final_price;
                    }
                }
            })
            let total_grossprice = cartTotal;
            if (paymentMethod !== 'Cash' && isReverseCard) {
                total_grossprice = totalPrice + pos_fee + donationCal(donationItems)
                if (orderType === "Delivery") {
                    total_grossprice += total_delivery_fee
                }
                if(couponDetails && couponPercentValue) {
                    total_grossprice -= couponDiscountCal(couponDetails, cartData)
                }
                total_grossprice = Math.round(total_grossprice * 100) / 100
            }
            if (cartData && cartData.length > 0) {
                let discount = 0;
                let quantity = 0;
                cartData.forEach((item: any) => {
                    item.tax_percent = tax;
                    if (item.combo) {
                        if (item.combo.discount_price || item.combo.discount_price == 0) {
                            discount += item.quantity * Math.round((item.combo.combo_mrp_price - item.combo.discount_price) * 100) / 100;
                        }
                        quantity += item.quantity;
                    } else {
                        quantity += item.quantity;
                        if (item.selectedsize.discount_price || item.selectedsize.discount_price == 0) {
                            let price: any = item.selectedsize.mrp - item.selectedsize.discount_price;
                            discount += item.quantity * (price).toFixed(2);
                        }
                        {
                            item.modifiers && Object.keys(item.modifiers).map(
                                (key: any, index) => {
                                    item.modifiers[key].map(
                                        (obj: any, index: any) => {
                                            let price: any = obj.modifier_sale_price - obj.discount_price;
                                            if (obj.selected === true && (obj.discount_price || obj.discount_price == 0)) {
                                                discount += obj.quantity * (price).toFixed(2)
                                            }
                                        })

                                }
                            )
                        }
                    }
                })

                cartData.forEach((item: any) => {
                    const baseItemPrice = item.price;
                    let { final_price, exclusive_tax } = calculatePrice(baseItemPrice, paymentMethod, taxDataCash, taxDataCard, isReverseCard);
                    final_price = final_price * item.quantity;
                    exclusive_tax = exclusive_tax * item.quantity;
                    if (item.modifiers) {
                        for (const key of Object.keys(item.modifiers)) {
                            for (const modItem of item.modifiers[key]) {
                                if (!modItem.selected) continue;

                                const isDiscountAvailable = modItem.discount_price || modItem.discount_price == 0;
                                modItem.tax_percent = tax;
                                modItem.originalPrice = isDiscountAvailable
                                    ? modItem.discount_price
                                    : modItem.modifier_sale_price;

                                const basePrice = modItem.originalPrice;
                                const { final_price: mod_final_price, exclusive_tax: mod_final_tax } = calculatePrice(basePrice, paymentMethod, taxDataCash, taxDataCard, isReverseCard);
                                final_price += mod_final_price * modItem.quantity;
                                exclusive_tax += mod_final_tax * modItem.quantity;
                                modItem.tax_amount = Math.round(mod_final_tax * 100) / 100;
                                isReverseCard && (isDiscountAvailable
                                    ? modItem.discount_price = mod_final_price
                                    : modItem.modifier_sale_price = mod_final_price);
                                modItem.tax_type = taxDataCash ? taxDataCash.tax_type : 0
                            }
                        }
                    }
                    item.tax_amount = Math.round(exclusive_tax * 100) / 100;
                    item.totalItemPrice = Math.round(final_price * 100) / 100;

                })
                let customer_token: any = localStorage.getItem("userToken")

                let cartWithDonation: any[] = []
                if (donationItems?.length > 0) {
                    donationItems.forEach((element: any) => {
                        element.donation_id = element.donation_id;
                        element.tax_percent = tax;
                        element.tax_amount = 0;
                        element.selectedsize = null;
                    })
                    cartWithDonation = [...cartData, ...donationItems]
                }

                const token = await localStorage.getItem("userToken");
                const couponPercentValue = (couponDetails && !couponDeliveryFree && (couponDetails.coupon_type.type == "percent" || couponDetails.coupon_type.type == "value")) ? 1 : 0;
                if ((orderType !== "" && !_.isEmpty(storeSelected))) {
                    if (token) {

                        let obj: any = {
                            order_status_code: 1,
                            order_grossprice: Math.round(((taxDataCash && taxDataCash.tax_type == 1) ? cartTotal + (cartTotal * tax / 100) : total_grossprice) * 100) / 100,
                            discount: couponPercentValue ? 0 : Math.round(discount * 100) / 100,
                            order_channel: "Web",
                            store_id: storeSelected.store_id,
                            branch_code: activeStore.branch_code,
                            delivery_status: orderType,
                            special_inst: special_ins,
                            alternate_phone_number: `${PHONE_CODE}-` + alt_num,
                            payment_method: paymentMethod,
                            uniqueOrderId: uniqueOrderId,
                            cartItems: cartWithDonation.length > 0 ? cartWithDonation : cartData,
                            check_number: '',
                            tax_percent: tax,
                            quantity: quantity,
                            lat: lat,
                            lng: lng,
                            deliveryLat: changeLat,
                            deliveryLng: changeLng,
                            pos_service_fee: pos_fee,
                            device_info: device_info,
                            device_os: device_os,
                            req_customer_ip_address: ip_address,
                            jazz_cash_phone: 0 + phone_number,
                            coupon_id: couponDetails ? couponDetails.coupon_id : null,
                            coupon_discount_value: couponPercentValue ? couponDiscountCal(couponDetails, cartData) : 0,
                            coupon_code: couponDetails ? couponDetails.coupon_code : null
                        };
                        if (orderTime == "later") {
                            obj.future_status = 1;
                            obj.future_date = moment(orderLaterDateTime).utc(false).format('YYYY-MM-DD HH:mm')
                            obj.laterdatetime = new Date(orderLaterDateTime);
                        }
                        if (!_.isEmpty(coupon)) {
                            obj.coupon = coupon;
                            obj.coupon_redeem = 1;
                            obj.coupon_code = coupon.coupon_code;
                            obj.coupon_discount_value = 0;
                        }
                        if (orderType == "Delivery") {
                            // Save Address With Maps
                            obj.delivery_address = delivery_address;
                            obj.geocoded_address = geocoded_address;
                            obj.address = extra_address;

                            obj.order_netprice = Math.round((total_grossprice - total_delivery_fee - pos_fee) * 100) / 100;
                            obj.tax_amount = calcTotalGstTax(cartData, paymentMethod, isReverseCard, taxDataCash, taxDataCard, orderType, total_delivery_fee, "orderSummary");
                            obj.tax_type = taxDataCash ? taxDataCash.tax_type : 0;
                            obj.order_grosspricewd = Math.round(((taxDataCash && taxDataCash.tax_type == 1) ? obj.order_netprice + pos_fee + obj.tax_amount : obj.order_netprice + pos_fee) * 100) / 100
                            obj.delivery_fee = total_delivery_fee;
                            obj.delfee_tax_amount = Math.round(total_delivery_fee * (parseInt(tax) / (100 + parseInt(tax))) * 100) / 100
                        } else if (orderType == "Pickup" || orderType == "Qr-Pickup") {

                            obj.order_netprice = Math.round((total_grossprice - pos_fee) * 100) / 100;
                            obj.tax_amount = calcTotalGstTax(cartData, paymentMethod, isReverseCard, taxDataCash, taxDataCard, orderType, 0, "orderSummary");
                            obj.tax_type = taxDataCash ? taxDataCash.tax_type : 0;
                            obj.order_grosspricewd = Math.round(((taxDataCash && taxDataCash.tax_type == 1) ? obj.order_netprice + pos_fee + obj.tax_amount : obj.order_netprice + pos_fee) * 100) / 100
                            obj.pickup_time = pickup_time;
                        }
                        if (paymentMethod == "Card") {
                            obj.bill_to_address_city = storeSelected?.city;
                            obj.bill_to_address_country = "PK";
                            obj.card_expiry_date = `${card_expiry_month}-${card_expiry_year}`;
                            obj.isSaveCard = (isNewCard || cardTokens.length == 0) ? isSaveCard : null;
                            obj.card_number = card_number;
                            obj.card_token = CustomercardToken != null ? CustomercardToken.payment_token : null
                        }
                        if (customer_token) {
                            obj.customer_token = customer_token
                        } else {
                            obj.bill_to_forename = guestInfo.first_name;
                            obj.bill_to_surname = guestInfo.last_name;
                            obj.bill_to_email = guestInfo.email_address;
                        }
                        if (orderTime == "later") {
                            if (activeStore.isDays == 0) {
                                compareLaterOpenClosingTime(activeStore, obj);
                            }
                            else if (activeStore.isDays == 1) {
                                compareLaterTimingbyEachDay(activeStore, obj)
                            }
                        } else if (orderTime == "now") {
                            if (activeStore.isDays == 0) {
                                compareOpenClosingTime(activeStore, obj);
                            }
                            else if (activeStore.isDays == 1) {
                                compareTimingbyEachDay(activeStore, obj, orderType == "Delivery" ? 'delivery' : 'pickup')
                            }
                        }
                    } else {
                        let obj: any = {
                            order_status_code: 1,
                            order_grossprice: Math.round(((taxDataCash && taxDataCash.tax_type == 1) ? cartTotal + (cartTotal * tax / 100) : total_grossprice) * 100) / 100,
                            discount: couponPercentValue ? 0 : Math.round(discount * 100) / 100, // Set discount to 0 when voucher is applied
                            order_channel: "Web",
                            store_id: storeSelected.store_id,
                            branch_code: activeStore.branch_code,
                            delivery_status: orderType,
                            special_inst: special_ins,
                            alternate_phone_number: `${PHONE_CODE}-` + alt_num,
                            payment_method: paymentMethod,
                            uniqueOrderId: uniqueOrderId,
                            cartItems: cartWithDonation.length > 0 ? cartWithDonation : cartData,
                            check_number: '',
                            tax_percent: tax,
                            quantity: quantity,
                            lat: lat,
                            lng: lng,
                            deliveryLat: changeLat,
                            deliveryLng: changeLng,
                            pos_service_fee: pos_fee,
                            device_info: device_info,
                            device_os: device_os,
                            req_customer_ip_address: ip_address,
                            jazz_cash_phone: 0 + phone_number,
                            coupon_id: couponDetails ? couponDetails.coupon_id : null,
                            coupon_discount_value: couponPercentValue ? couponDiscountCal(couponDetails, cartData) : 0,
                            coupon_code: couponDetails ? couponDetails.coupon_code : null
                        };
                        if (!_.isEmpty(coupon)) {
                            obj.coupon = coupon;
                            obj.coupon_redeem = 1;
                            obj.coupon_code = coupon.coupon_code;
                            obj.coupon_discount_value = 0;
                        }
                        if (orderTime == "later") {
                            obj.future_status = 1;
                            obj.future_date = moment(orderLaterDateTime).utc(false).format('YYYY-MM-DD HH:mm')
                            obj.laterdatetime = new Date(orderLaterDateTime);
                        }
                        if (orderType == "Delivery") {
                            obj.delivery_address = delivery_address;
                            obj.geocoded_address = geocoded_address;
                            obj.address = extra_address;
                            obj.order_netprice = Math.round((total_grossprice - total_delivery_fee - pos_fee) * 100) / 100;
                            obj.tax_amount = calcTotalGstTax(cartData, paymentMethod, isReverseCard, taxDataCash, taxDataCard, orderType, total_delivery_fee, "orderSummary");
                            obj.tax_type = taxDataCash ? taxDataCash.tax_type : 0;
                            obj.order_grosspricewd = Math.round(((taxDataCash && taxDataCash.tax_type == 1) ? obj.order_netprice + pos_fee + obj.tax_amount : obj.order_netprice + pos_fee) * 100) / 100
                            obj.delivery_fee = total_delivery_fee;
                            obj.delfee_tax_amount = Math.round(total_delivery_fee * (parseInt(tax) / (100 + parseInt(tax))) * 100) / 100
                        } else if (orderType == "Pickup" || orderType == "Qr-Pickup") {
                            obj.order_netprice = Math.round((total_grossprice - pos_fee) * 100) / 100;
                            obj.tax_amount = calcTotalGstTax(cartData, paymentMethod, isReverseCard, taxDataCash, taxDataCard, orderType, 0, "orderSummary");
                            obj.tax_type = taxDataCash ? taxDataCash.tax_type : 0;
                            obj.order_grosspricewd = Math.round(((taxDataCash && taxDataCash.tax_type == 1) ? obj.order_netprice + pos_fee + obj.tax_amount : obj.order_netprice + pos_fee) * 100) / 100
                            obj.pickup_time = pickup_time;
                        }
                        obj.customer_id = guestInfo.customer_id;
                        obj.guest = true;
                        if (orderTime == "later") {
                            if (activeStore.isDays == 0) {
                                compareLaterOpenClosingTime(activeStore, obj);
                            }
                            else if (activeStore.isDays == 1) {
                                compareLaterTimingbyEachDay(activeStore, obj)
                            }
                        } else if (orderTime == "now") {
                            if (activeStore.isDays == 0) {
                                compareOpenClosingTime(activeStore, obj);
                            }
                            else if (activeStore.isDays == 1) {
                                compareTimingbyEachDay(activeStore, obj, orderType == "Delivery" ? 'delivery' : 'pickup')
                            }
                        }
                    }
                }

            }
        } else {
            setLoader(false)
            setRadioBtn(false)
            toast.error(t("STORE_CLOSED"), {
                position: toast.POSITION.TOP_RIGHT,
                hideProgressBar: true,
                autoClose: 3000,
            });
        }
    };
    const updateCartInOriginalStateAfterException = () => {
        cartData.forEach((item: any) => {
            if (paymentMethod !== 'Cash' && isReverseCard) {
                let originalPrice = item.selectedsize ? item.selectedsize.mrp * item.quantity : item.combo.combo_mrp_price * item.quantity;
                let totalModPrice = 0;
                if (item.modifiers) {
                    Object.keys(item.modifiers).map((key: any) => {
                        item.modifiers[key].map(
                            (modItem: any, index: any) => {
                                if (modItem.selected == true) {
                                    totalModPrice += (modItem.originalPrice * modItem.quantity)
                                    modItem.modifier_sale_price = modItem.originalPrice
                                }
                            })
                    })
                }
                item.totalItemPrice = originalPrice + totalModPrice;
            }
        })
    }
    const updateLoaderButton = () => {
        setLoader(false)
        setRadioBtn(false)
        setUniqueId(new Date().getTime())
    }
    const showErrorMessage = (message: any) => {
        errorMesage = message;
    }
    const showPaymentPendingMessage = (message: any) => {
        paymentPendingMessage = message;
    }
    const shippingInfo = () => {
        let items: any = []
        let totalAmmount = 0
        let shippingInfo: any = {
            currency: 'PKR'
        }
        cartData.forEach((item: any) => {
            let obj = {
                item_id: item.combo ? item.combo.combo_id : item.item.menu_item_id,
                item_name: item.combo ? item.combo.combo_name : item.item.item_name,
                discount: item.item && item?.selectedsize?.discount_value ? item.selectedsize.discount_value : item.combo?.discount_value ? item.combo.discount_value : 0,
                quantity: item.quantity,
                price: item.totalItemPrice,
                index: item.combo ? item.combo.priority : item.item.priority,
                item_category: item.combo ? item.combo.group_id.group_name : item.item.item_group_id.group_name
            }
            totalAmmount += item.totalItemPrice
            items.push(obj)
        })
        shippingInfo['items'] = items;
        shippingInfo['value'] = totalAmmount
        shippingInfo['shipping_tier'] = orderType == "Delivery" ? 'Delivery' : 'Pickup';

        let windowObj = (window as any)
        windowObj.dataLayer.push({ ecommerce: null });
        windowObj.dataLayer.push({
            'event': 'add_shipping_info',
            'ecommerce': {
                'shipping_info': shippingInfo
            }
        });
    }
    const paymentTracking = (activity: any) => {
        let token: any = localStorage.getItem("userToken");
        let userData: any = jwtDecode(token)
        let totalDeliveryFee = 0;
        if (paymentMethod && paymentMethod !== 'Cash' && isReverseCard) {
            const delFee = calculateDeliveryFee();
            totalDeliveryFee += delFee;
        }
        let total_delivery_fee = (paymentMethod && paymentMethod !== 'Cash' && isReverseCard) ? orderType == "Delivery" ? totalDeliveryFee : 0 : deliveryfee;
        if(couponDeliveryFree) {
            total_delivery_fee = 0;
        }
        let totalPrice = 0;
        cartData.forEach((item: any) => {
            if (paymentMethod && paymentMethod !== 'Cash' && isReverseCard) {
                const final_price = calcFinalPriceFromUnit(item, paymentMethod, taxDataCash, taxDataCard, isReverseCard)
                totalPrice += final_price;
            }
        })
        const total_grossprice = (paymentMethod && paymentMethod !== 'Cash' && isReverseCard) ? orderType == "Delivery" ? totalPrice + total_delivery_fee + pos_fee : totalPrice + pos_fee : cartTotal;
        let obj = {
            unique_order_id: uniqueId,
            customer_id: userData.customer.customer_id,
            store_id: storeSelected.store_id,
            ip_address: ip_address,
            activity: activity,
            total_amount: total_grossprice
        }
        props.saveTrackingLogs(obj);
    }
    const taxCalculations = () => {
        let obj = {
            store_id: storeSelected.store_id,
            delivery_fee: deliveryfee,
            total_amount: orderType === 'Pickup' ? cartTotal - pos_fee : cartTotal - deliveryfee - pos_fee
        }
        props.getTax(obj);
    }
    const selectedCardByCustomer = (card: any) => {
        setCustomercardToken(card)
    }
    const isPaymentButtonEnabled = () => {
        if (paymentMethod == "Card") {
            if (cardTokens.length == 0) {
                return true
            }
            if (isNewCard) {
                return true
            }
            else if (cardTokens && cardTokens.length > 0) {
                if (CustomercardToken == null) {
                    return false
                }
                else {
                    return true
                }
            }
            return false
        }
        else {
            if (paymentMethod !== "") {
                if (paymentMethod == "JazzWallet") {
                    return phoneError ? false : true
                }
                return true
            }
            else {
                return false
            }
        }
    }
    const taxCalculationsOnItems = (payment_method: any) => {
        cartData.forEach((item: any) => {
            if (payment_method && payment_method !== 'Cash' && isReverseCard) {
                const final_price = calcFinalPriceFromUnit(item, payment_method, taxDataCash, taxDataCard, isReverseCard);
                item.updateOnlineItemPrice = final_price;
            } else {
                item.updateOnlineItemPrice = 0
            }
        })
    }
    const updateOnlineDeliveryfee = (payment_method: any) => {
        if (payment_method && payment_method !== 'Cash' && isReverseCard) {
            const delFee = calculateDeliveryFee();
            props.updateOnlineDeliveryFee(delFee)
        } else {
            props.updateOnlineDeliveryFee(0)
        }
    }
    const calculateDeliveryFee = () => {
        const inclusive_tax: any = deliveryfee * parseInt(taxDataCash.tax_percent) / (100 + parseInt(taxDataCash.tax_percent));
        const exclusive_value = deliveryfee - inclusive_tax;
        const exclusive_tax = Math.round(exclusive_value * taxDataCard.tax_percent) / 100;
        const delFee = Math.round((exclusive_value + exclusive_tax) * 100) / 100;
        return delFee;
    }
    const calculationAfterPaymentMethodSelection = (payment_method: any) => {
        updateOnlineDeliveryfee(payment_method)
        taxCalculationsOnItems(payment_method)
    }
    return (
      <>
        <div className="bucket-conainet-sticky">
          <div className="basket-items">
            <div className="item-add">
              <h3>{t("ORDER_SUMMARY")}</h3>
              <div className="kfc-box-theme">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
            <div className="add-to-basket">
              {cartData && cartData.length > 0 ? (
                cartData.map((carts: any, index: any) => {
                  return (
                    <CartItems
                      carts={carts}
                      key={index}
                      index={index}
                      setValue={setValue}
                      value={value}
                      setHeaderUpdate={props.setHeaderUpdate}
                      headerUpdate={props.headerUpdate}
                      isOrderSummary={true}
                    />
                  );
                })
              ) : (
                <div className="kfc-basket" style={{ aspectRatio: 0 }}>
                  <img src={KfcMeal} alt="" />
                  <h5 className="font-bold">
                    {t("NO_ITEMS_IN_BUCKET")}
                  </h5>
                  <Link className="font-bold" to={`/${lang}/menu`}>
                    <button>{t("EXPLOREMENU")}</button>
                  </Link>
                </div>
              )}
              <OrderDetail
                orderType={orderType}
                onlineDeliveryfee={onlineDeliveryfee}
                deliveryfee={deliveryfee}
                pos_fee={pos_fee}
                storeSelected={storeSelected}
              />
            </div>
          </div>
          {cartData.length > 0 && (
            <button className="border-0 bg-transparent" onClick={handleShow}>
              <div className="kfc-card-price bar-adjustment">
                <div className="d-flex justify-content-between cart-dir-arabic">
                  <div className="d-flex align-items-center gap-10">
                    <h6 className="font-normal mb-0">
                      {cartQty} {cartQty > 1 ? t("ITEMS") : t("ITEM")}
                    </h6>
                    <h5 className="kfc-mmm">
                      | {priceunit + formatPrice(calcTotal(cartData))}
                    </h5>
                  </div>
                  <div className="d-flex align-items-center">
                    <h6 className="order-summer-kfc px-2">
                      {t("SELECT_PAYMENT_MODE")}
                    </h6>
                    <i className="ri-arrow-right-s-line errow-line"></i>
                  </div>
                </div>
              </div>
            </button>
          )}
        </div>

        <Modal
          className="payment-modal"
          show={show}
          onHide={handleClose}
          backdrop="static"
          centered
        >
          <div className="modal-design">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <Modal.Header
            className="justify-content-center"
            closeButton={loader ? false : true}
          >
            <div className="row">
              <div className="col-12 text-center">
                <Modal.Title className="font-bold">
                {t("SELECT_PAYMENT_MODE")}
                </Modal.Title>
              </div>
              {activeStore?.tax_inclusive && (
                <div className="col-12 text-center mt-3">
                  <p style={{ fontSize: 13 }}>
                    {t("PAYMENT_TAX_NOTICE")}
                  </p>
                </div>
              )}
            </div>
          </Modal.Header>
          <Modal.Body className="w-100 delivery-order">
            <PaymentMode
              calculationAfterPaymentMethodSelection={
                calculationAfterPaymentMethodSelection
              }
              newCard={newCardHandler}
              isNewCard={isNewCard}
              cardTokens={cardTokens}
              selectedCard={selectedCardByCustomer}
              userCardToken={CustomercardToken}
              paymentTracking={paymentTracking}
              monthError={monthError}
              yearError={yearError}
              cardError2={cardError2}
              handleCardError2={handleCardError2}
              cvcError={cvcError}
              payment_modes={payment_modes}
              paymentMethod={paymentMethod}
              savePaymentMethod={props.savePaymentMethod}
              emptyPaymentMethod={props.emptyPaymentMethod}
              radioButton={radioButton}
              handleCardExpireMonth={handleCardExpireMonth}
              card_expiry_month={card_expiry_month}
              handleCardExpireYear={handleCardExpireYear}
              card_expiry_year={card_expiry_year}
              handleCardNumber={handleCardNumber}
              card_number={card_number}
              handleCardCVN={handleCardCVN}
              cvn={cvn}
              setJazzCashPhone={setJazzCashPhone}
              setJazzCashPhoneError={setJazzCashPhoneError}
              phone_number={phone_number}
              phoneError={phoneError}
              loader={loader}
              jazzcash={isJazzCash}
              handleSaveDetails={handleSaveDetails}
            />
            {paymentMethod !== "CDD" && (
              <div className="d-flex justify-content-between gap-10 mb-4">
                <Button
                  onClick={() => (loader ? null : handleClose())}
                  className="w-50 m-auto d-flex mt-4 color-white"
                  variant="outlined"
                  color="error"
                >
                  {t("CANCEL")}
                </Button>
                {loader ? (
                  <Button
                    className="w-50 m-auto d-flex mt-4 bg-theme"
                    variant="contained"
                    color="error"
                  >
                    {<CircularProgress size={25} color={"inherit"} />}
                  </Button>
                ) : (
                  <Button
                    onClick={() => {
                      setRadioBtn(true);
                      setLoader(true);
                      let token: any = localStorage.getItem("userToken");
                      if (isLogged || guestInfo) {
                        if (token) {
                          let userData: any = jwtDecode(token);
                          props.getProfile(
                            userData.customer.customer_id,
                            confirmOrder,
                            setRadioBtn,
                            history
                          );
                        }
                      }
                      mergn.recordEvent("Order Placed", [
                        { eventProperty: "total", value: cartTotal },
                      ]);
                      paymentTracking(`Select Make Payment Button`);
                      shippingInfo();
                    }}
                    disabled={isPaymentButtonEnabled() ? false : true}
                    className={`${
                      isPaymentButtonEnabled() ? "able-btn" : "disable-btn"
                    } w-50 m-auto d-flex mt-4 bg-theme`}
                    variant="contained"
                    color="error"
                  >
                    {t("MAKE_PAYMENT")}
                  </Button>
                )}
              </div>
            )}
            {paymentMethod == "CDD" && (
              <div className="d-flex justify-content-between gap-10 mb-4">
                <Button
                  onClick={() => (loader ? null : handleClose())}
                  className="w-50 m-auto d-flex mt-4 color-white"
                  variant="outlined"
                  color="error"
                >
                  {t("CANCEL")}
                </Button>
                {loader ? (
                  <Button
                    className="w-50 m-auto d-flex mt-4 bg-theme"
                    variant="contained"
                    color="error"
                  >
                    {<CircularProgress size={25} color={"inherit"} />}
                  </Button>
                ) : (
                  <Button
                    onClick={() => {
                      setRadioBtn(true);
                      setLoader(true);
                      let token: any = localStorage.getItem("userToken");
                      if (isLogged || guestInfo) {
                        if (token) {
                          let userData: any = jwtDecode(token);
                          props.getProfile(
                            userData.customer.customer_id,
                            confirmOrder,
                            setRadioBtn,
                            history
                          );
                        }
                      }
                      mergn.recordEvent("Order Placed", [
                        { eventProperty: "total", value: cartTotal },
                      ]);
                      paymentTracking(`Select Make Payment Button`);
                      shippingInfo();
                    }}
                    disabled={paymentMethod !== "" ? false : true}
                    className={` ${
                      paymentMethod !== "" ? "able-btn" : "disable-btn"
                    } w-50 m-auto d-flex mt-4 bg-theme`}
                    variant="contained"
                    color="error"
                  >
                    {t("MAKE_PAYMENT")}
                  </Button>
                )}
              </div>
            )}
          </Modal.Body>
        </Modal>

        <Modal
          className="track-modal"
          show={successFlag}
          backdrop={"static"}
          centered
        >
          <div className="modal-design">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <Modal.Header className="justify-content-center"></Modal.Header>
          <Modal.Body className="w-100 delivery-order text-center">
            {t("ORDER_PLACED_TRACKING")} {order_id}
            <div className="d-flex justify-content-between gap-10">
              <Button
                onClick={handleTrack}
                className="m-auto d-flex mt-4 bg-theme mb-3"
                variant="contained"
                color="error"
              >
                {t("OK")}
              </Button>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          className="track-modal"
          show={showError}
          backdrop={"static"}
          centered
        >
          <div className="modal-design">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <Modal.Header className="justify-content-center"></Modal.Header>
          <Modal.Body className="w-100 delivery-order text-center">
            {errorMesage}
            <div className="d-flex justify-content-between gap-10">
              <Button
                onClick={() => setShowError(false)}
                className="m-auto d-flex mt-4 bg-theme mb-3"
                variant="contained"
                color="error"
              >
                {t("OK")}
              </Button>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          className="track-modal"
          show={showPaymentPending}
          backdrop={"static"}
          centered
        >
          <div className="modal-design">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <Modal.Header className="justify-content-center"></Modal.Header>
          <Modal.Body className="w-100 delivery-order text-center">
            {paymentPendingMessage}
            <div className="d-flex justify-content-between gap-10">
              <Button
                onClick={() => history.push(`/${lang}/`)}
                className="m-auto d-flex mt-4 bg-theme mb-3"
                variant="contained"
                color="error"
              >
                {t("OK")}
              </Button>
            </div>
          </Modal.Body>
        </Modal>

        {cartData.length > 0 && (
          <button className="border-0 bg-transparent" onClick={handleShow}>
            <div className="mobile-cart">
              <div className="d-flex justify-content-between">
                <div className="d-flex align-items-center gap-10">
                  <h6 className="font-normal mb-0">
                    {cartQty} {cartQty > 1 ? t("ITEMS") : t("ITEM")}
                  </h6>
                  <h5 className="kfc-mmm">
                    | {priceunit + formatPrice(calcTotal(cartData))}
                  </h5>
                </div>
                <div className="d-flex align-items-center ">
                  <h6 className="kfc-mmm px-2">{t("SELECT_PAYMENT_MODE")}</h6>
                  <i className="ri-arrow-right-s-line errow-line"></i>
                </div>
              </div>
            </div>
          </button>
        )}
        <Modal show={showValidteItemModal} center>
          <div className="modal-design">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <Modal.Header className="p-2">
            <Modal.Title className="font-bold h4 w-75 m-auto text-center ">
            {t("INVALID_CART_ITEMS")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="w-100 delivery-order">
            <div className="row">
              {removeableInvalidItemsArr &&
                removeableInvalidItemsArr.map((item: any, itemIndex: any) => (
                  <div
                    key={itemIndex}
                    className="col-lg-6 col-md-6 col-12 mt-4"
                  >
                    <div className="card-sujestive">
                      <div className="menue-card">
                        <img
                          className="menu-img w-100 mb-1"
                          src={`${IMAGE_URL}${
                            item.selectedsize
                              ? item.selectedsize.image_url
                              : item.combo.image_url
                          }`}
                          alt=""
                        />
                      </div>
                      <h5 className="card-header font-bold">
                        {" "}
                        {item.item && item.item.item_name}
                        {item.combo && item.combo.combo_name}
                      </h5>
                      <h6>{priceunit + formatPrice(item.newPrice)}</h6>
                    </div>
                  </div>
                ))}
            </div>
          </Modal.Body>
          <Modal.Footer className="justify-content-center">
            <Button
              variant="contained"
              color="error"
              className="btn cart-button bg-theme text-center"
              onClick={removeInvalidCartItem}
            >
              {t("CONFIRM")}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        getProfile: (id: any, confirmOrderFn: any, setRadioBtn: any, history: any) => {
            dispatch(getProfile(id, confirmOrderFn, setRadioBtn, null, history));
        },
        getTimezone: function (id: number) {
            return dispatch(getTimezone(id))
        },
        getTimezoneForLater: function (id: number) {
            return dispatch(getTimezoneForLater(id))
        },
        saveOrder: function (data: any, setLoader: any, handleClose: any, setShowError: any, showErrorMessage: any, updateLoaderButton: any, updateCartInOriginalStateAfterException: any) {
            dispatch(saveOrder(data, setLoader, handleClose, setShowError, showErrorMessage, updateLoaderButton, updateCartInOriginalStateAfterException));
        },
        savePaymentMethod: function (payment_method: any) {
            dispatch(savePaymentMethod(payment_method));
        },
        emptyPaymentMethod: () => {
            dispatch(emptyPaymentMethod())
        },
        saveOrderSuccessFlag: () => {
            dispatch(saveOrderSuccessFlag())
        },
        saveCart: function (cart: any[]) {
            dispatch(saveCart(cart));
        },
        saveCardOrder: function (data: any, updateLoaderButton: any, updateCartInOriginalStateAfterException: any, setShowPaymentPending: any, showPaymentPendingMessage: any, handleClose: any) {
            dispatch(saveCardOrder(data, updateLoaderButton, updateCartInOriginalStateAfterException, setShowPaymentPending, showPaymentPendingMessage, handleClose));
        },
        dumpCardTempOrder: (order: any, orderTime: any) => {
            dispatch(dumpCardTempOrder(order, orderTime))
        },
        getPaymentModes: (store_id: any) => {
            dispatch(getPaymentModes(store_id))
        },
        getCustomerCardDetails: () => {
            dispatch(cardDetails())
        },
        checkStoreActive: (store_id: any, orderType: any) => {
            dispatch(checkStoreActive(store_id, orderType))
        },
        saveTrackingLogs: function (logs: any[]) {
            dispatch(saveTrackingLogs(logs));
        },
        getTax: function (data: any) {
            dispatch(getTax(data));
        },
        updateOnlineDeliveryFee: function (delivery_fee: any) {
            dispatch(updateOnlineDeliveryFee(delivery_fee));
        }
    };
};

export default connect(null, mapDispatchToProps)(OrderSumary);